import {AreaChart} from '@crema/modules/thirdParty';
export default AreaChart;
